import { createSelector } from '@reduxjs/toolkit'

const getLoaders = state => state.loader

export const selectLoaderList = createSelector(getLoaders, loader => loader.list)

export const selectLoaderExists = (state, loader) => selectLoaderList(state).indexOf(loader) > -1
